import React, { useState, useEffect } from "react";

export const svg = `<svg width="14" height="12" viewbox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.136.69c2.91-.222 5.388 1.198 5.524 3.145.106 1.427-1.091 2.756-2.887 3.443.06.175.091.35.106.534.144 1.947-2.091 3.619-5.016 3.832-2.925.214-5.38-1.122-5.524-3.069C.241 7.148 1.43 5.82 3.226 5.132a2.156 2.156 0 0 1-.106-.534C2.976 2.651 5.226.911 8.136.689ZM1.771 8.3c-.129.917 1.349 2.207 4.016 1.985 2.667-.221 3.478-1.328 3.077-2.572a2.32 2.32 0 0 0-.073.009 1.209 1.209 0 0 1-.162.014c-1.902.137-3.622-.428-4.622-1.382-1.107.229-2.1 1-2.236 1.947Z" fill="#E3E5EA"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
